import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { initApp } from '@provise/init'
import App from '@provise/app.vue'
import router from '@/router'

const app = createApp(App)

app.config.globalProperties.defaultTitle = 'TRACE'
app.use(createPinia())
app.use(router)

initApp(app)

app.mount('#app')
